module.exports = "agm-map {\n  height: 300px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/spot-detail/spot-detail.component.css
// module id = ./src/app/spot-detail/spot-detail.component.css
// module chunks = main